import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import mapDispatchToProps from './command.tsx';
import mapStateToProps from './query.tsx';
import View from './view.tsx';

export default connect(mapStateToProps, mapDispatchToProps)(View);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { default as ShareReport } from './view';
